import { AFFIRMATION_TYPES } from './AffirmationData'
import NavigationCard from './NavigationCard'
import Wrapper from './Wrapper'

export default function AffirmationsApp() {
  return (
    <Wrapper>
      <div className="flex min-h-0 w-full max-w-none min-w-0 shrink grow flex-col items-center gap-2">
        <div className="flex flex-col items-center gap-2 text-center sm:gap-4 md:gap-6">
          <h1 className="choice-container-title text-4xl font-medium tracking-wide">
            What do you need today?
          </h1>
          <h2 className="choice-container-title text-2xl font-normal italic">
            Take a look and choose what feels most helpful right now.
          </h2>
        </div>
        <div className="cards-container flex min-h-0 w-full flex-1 items-center justify-center">
          <div className="nav-cards-container min-h-0 w-full flex-1 content-center pb-20 sm:pb-0">
            <NavigationCard
              to={`choice/${AFFIRMATION_TYPES.DAILY}`}
              className="affirmation-type-daily"
              title="Daily Affirmations"
              text="Soft reminders for daily life"
            />
            <NavigationCard
              to={`choice/${AFFIRMATION_TYPES.SELF_LOVE}`}
              className="affirmation-type-self-love"
              title="Self-Love Affirmations"
              text="Supportive words for self-worth"
            />
            <NavigationCard
              to={`choice/${AFFIRMATION_TYPES.WOMEN}`}
              className="affirmation-type-women"
              title="Affirmations for Women"
              text="Words of strength, grace and growth"
            />
            <NavigationCard
              to={`choice/${AFFIRMATION_TYPES.ANXIETY}`}
              className="affirmation-type-anxiety"
              title="Affirmations for Anxiety"
              text="Calm your mind and find peace"
            />
            <NavigationCard
              to={`choice/${AFFIRMATION_TYPES.QUOTES}`}
              className="affirmation-type-quotes"
              title="Quotes"
              text="Inspirational quotes by famous people"
            />
          </div>
        </div>
      </div>
    </Wrapper>
  )
}
